export default "__VITE_ASSET__BoeYJoBT__"